// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2AgPV","colCheckbox":"styles_colCheckbox__3pfsG"};